import React from 'react';

const Footer = ({ basics }) => (
	<footer id="portfolio-footer">
		<p>Last Updated: {basics.lastUpdated}</p>
	</footer>
);

export default Footer;
